





import AbpBase from "../../../lib/abpbase"
import {Component} from "vue-property-decorator"
import Primary from './parts/primary.vue'
@Component({
	components: {Primary}
})
export default class Age extends AbpBase {

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/primaryDisease/index.vue